export default "__VITE_ASSET__Df2KP2Rr__"